import React from "react";

const NavButton = ({ title, customFunc, icon, color, dotColor, isDotOn }) => (
  <button
    type="button"
    onClick={() => customFunc()}
    style={{ color }}
    className={`relative text-3xl rounded-full${
      title === "Sidebar" ? "hover:bg-transparent" : "hover:bg-light-gray"
    }`}
  >
    {isDotOn && (
      <span
        style={{ background: dotColor }}
        className="absolute -right-1.5 bottom-0 h-4 w-4 animate-pulse inline-flex border-white border-2 rounded-full"
      />
    )}
    {icon}
  </button>
);

export default NavButton;
